"use client";

import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";
import { sha256 } from "js-sha256";
import useCookieConsent from "@/hooks/useCookieConsent";

export default function FacebookPixel() {
    const { data: session, status } = useSession();
    const initialized = useRef(false);
    // Le SDK n'est chargé qu'avec l'accord « publicité » (lib/cookieConsent.js)
    const marketingAllowed = useCookieConsent()?.marketing === true;

    useEffect(() => {
        if (!marketingAllowed) return;
        // Attendre que la session soit résolue (pas en loading)
        if (status === "loading") return;
        if (initialized.current) return;
        if (typeof window === "undefined" || !window.fbq) return;

        const pixelId = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
        if (!pixelId) return;

        // Advanced Matching : envoyer les données utilisateur si connecté
        if (session?.user) {
            const advancedMatching = {};

            if (session.user.email) {
                advancedMatching.em = session.user.email.toLowerCase().trim();
            }
            if (session.user.firstName) {
                advancedMatching.fn = session.user.firstName
                    .toLowerCase()
                    .trim();
            }
            if (session.user.lastName) {
                advancedMatching.ln = session.user.lastName
                    .toLowerCase()
                    .trim();
            }
            // La session porte `userId`, jamais `id` : l'external_id ne
            // partait donc jamais. C'est la seule clé que le serveur peut
            // hacher à l'identique (app/api/meta/event), donc la seule qui
            // rapproche une visite anonyme d'un achat connecté.
            if (session.user.userId) {
                advancedMatching.external_id = sha256(
                    String(session.user.userId),
                );
            }

            window.fbq("init", pixelId, advancedMatching);
        } else {
            window.fbq("init", pixelId);
        }

        window.fbq("track", "PageView");
        initialized.current = true;
    }, [session, status, marketingAllowed]);

    return null;
}
